import { EuiFlexGroup, EuiFlexItem, EuiTitle } from "@elastic/eui";
import React from "react";
import EntityIcon from "../EntityIcon";

function ProfileTabName({ label, entityName, icon, size = "xxs", hideIcon }) {
    return (
        <EuiFlexGroup
            gutterSize="xs"
            responsive={false}
        >
            {!hideIcon && (
                <EuiFlexItem grow={false}>
                    {icon || <EntityIcon entityName={entityName} />}
                </EuiFlexItem>
            )}
            <EuiFlexItem>
                <EuiTitle size={size}>
                    <h2>{label}</h2>
                </EuiTitle>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
}

export default ProfileTabName;
